import { Button, Form } from "react-bootstrap";
import { Modal, MuniSpinner2 } from "../../../components";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import useActas from "../../../api/actas";
import { useContext, useEffect, useState } from "react";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";
import { dictaminarActaHandler } from "../../../handlers/accionActa.handler";
import { UserContext } from "../../../context";

const ModalDictamen = ({ modals, handlerModal, setRefetch }) => {

    //? ESTADOS GLOBALES
    const { loads } = useGeneralAppStore();
    const { actaDetalle } = useActaDetalleStore();

    //TODO API
    const { cambiarEstadoDescargo } = useActas();
    const [observacion, setObservacion] = useState("");
    const [expediente, setExpediente] = useState();
    const { actions } = useContext(UserContext);

    useEffect(() => {
        return () => {
            handlerModal({ modal: false, modalName: "modal_dictaminar_acta" })
        }
    }, [])

    return (
        <Modal
            show={modals.includes('modal_dictaminar_acta')}
            size={"md"}
            onHide={() => handlerModal({ modal: false, modalName: "modal_dictaminar_acta" })}
            title={() => "Dictaminar acta"}
        >

            <div className="d-flex flex-column gap-2 position-relative">
                {
                    loads.includes('dictaminar') &&
                    <div className="position-absolute w-100 h-100 d-flex justify-content-center align-items-center " style={{ background: "rgba(255,255,255,0.8)", zIndex: "999" }}>
                        <MuniSpinner2 />
                    </div>

                }
                <Form.Group>
                    <Form.Label>N° Expediente: </Form.Label>
                    <Form.Control
                        defaultValue={expediente}
                        type="text"
                        onChange={(e) => { setExpediente(e.target.value) }}
                    />
                </Form.Group>
                <Form.Group>
                    <Form.Label>Observación: </Form.Label>
                    <Form.Control
                        onChange={(e) => { setObservacion(e.target.value) }}
                        style={{ resize: "none" }}
                        as={'textarea'}
                        rows={4}
                    />
                </Form.Group>
                <div style={{ minHeight: "50px" }} className="d-flex flex-column">
                    {(observacion == "") && <span className="text-danger">Dege agregar una observación</span>}
                    {(expediente == "") && <span className="text-danger">Debe un N° de expediente</span>}
                </div>
                <hr />
                <div className="d-flex justify-content-end gap-2">
                    <Button
                        variant="dark"
                        size="sm"
                        style={{ width: "fit-content" }}
                        onClick={() =>
                            dictaminarActaHandler({ generar_pago: false, numero_acta: actaDetalle.acta.numero_infraccion, observacion: observacion, numero_expediente: expediente }, setRefetch)
                        }
                        disabled={loads.includes('dictamen') || (observacion == "") || (expediente == "")}
                    >
                        {loads.includes('dictamen')
                            ? "Guardando cambios..."
                            : "Dictaminar"}
                    </Button>
                    {/* {
                        actions?.hasPermission('dictamen.pagovoluntario.create') &&
                        <Button
                            variant="dark"
                            size="sm"
                            style={{ width: "fit-content" }}
                            onClick={() =>
                                // dictaminarActaHandler({ generar_pago: true, numero_acta: actaDetalle.acta.numero_infraccion, observacion: observacion, numero_expediente: expediente }, setRefetch)
                                dictaminarActaHandler({ numero_acta: actaDetalle.acta.numero_infraccion, observacion: observacion, numero_expediente: expediente }, setRefetch)
                            }
                            disabled={loads.includes('dictamen') || (observacion == "") || (expediente == "")}
                        >
                            {loads.includes('dictamen')
                                ? "Guardando cambios..."
                                : "Dictaminar generando pago"}
                        </Button>
                    } */}
                </div>
            </div>

        </Modal>
    );
}
export default ModalDictamen;